<template>
  <v-container fluid dark class="choiceplayback white--text">
    <div v-if="bSceneDoesntExist">
          Hrm...this scene doesn't exist
    </div>
    <v-card v-if="!bTTSIsAvailable">
        Sorry, this app uses text to speech, which is not available in your browser.
        <br><br>
        Try using Google Chrome, which includes many text to speech voices.
    </v-card>
    <v-card v-if="!bLocalStorageIsAvailable">
        This app uses local storage, which is not available (or disabled) in your browser.
        <br><br>
        If you have disabled cookies, you will need to enable them to use this site.  We use local storage to save your work, not track you.  Please see our <a href="/privacy">privacy</a> policy for more information.
    </v-card>
    <div v-if="bSceneIsNotOwnedByMe">
          This scene can not be edited because it is owned by someone else.
        <v-btn
          v-on:click="onMakeCopy()"
          color="green"
        >
          Make a copy
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import helper from '../helper'
export default {
  name: 'error-messages',
  props: {
    bSceneDoesntExist: true,
    bSceneIsNotOwnedByMe: true
  },
  data () {
    return {
      bTTSIsAvailable: true,
      bLocalStorageIsAvailable: true
    }
  },
  computed: {
  },
  methods: {
    onMakeCopy: function () {
      this.$emit('makeCopy')
    },
    created: function () {
      if (!helper.isTTSAvailable()) {
        this.$emit('ttsNotSupported')
      }
      if (!helper.isLocalStorageAvailable()) {
        this.$emit('localStorageNotSupported')
      }
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ErrorMessages.vue